import { ChevronDown, MapPin } from "lucide-react";
import React, { useEffect, useState } from "react";
import { usePremisesStore, useRegionStore } from "../../store/store";

interface DropdownOption {
  id: string;
  name: string;
}
interface DropdownProps {
  selectedValue: string;
  onChange: (value: string) => void;
  type: "region" | "premises";
  selectedRegion?: string;
  disabled?: boolean;
}

export const Dropdown: React.FC<DropdownProps> = ({
  selectedValue,
  onChange,
  type,
  selectedRegion,
}) => {
  const [options, setOptions] = useState<DropdownOption[]>([]);
  const {
    allPremises,
    fetchPremises,
    loading: premisesLoading,
  } = usePremisesStore();
  const { regions, fetchRegions, loading: regionsLoading } = useRegionStore();

  useEffect(() => {
    if (!allPremises.length) fetchPremises();
    if (!regions.length) fetchRegions();
  }, []);

  useEffect(() => {
    if (allPremises.length > 0 && regions.length > 0) {
      if (type === "region") {
        // const uniqueRegions = Array.from(new Set(allPremises.map((premise: any) => premise.region.trim())));
        const uniqueRegions = regions.map((region: any) => ({
          id: region._id,
          name: region?.regionName?.trim(),
        }));
        setOptions(uniqueRegions);
      } else if (type === "premises") {
        if (!selectedRegion) {
          const uniqueFacilities = Array.from(
            new Set(
              allPremises.map((premise: any) =>
                JSON.stringify({
                  id: premise._id,
                  name: premise.premisesName.trim(),
                })
              )
            )
          ).map((item) => JSON.parse(item));
          setOptions(uniqueFacilities);
        } else {
          const filteredFacilities = allPremises
            .filter((premise: any) => premise.region === selectedRegion)
            .map((premise: any) => ({
              id: premise._id,
              name: premise.premisesName.trim(),
            }));
          const uniqueFacilities = Array.from(
            new Set(filteredFacilities.map((f) => JSON.stringify(f)))
          ).map((item) => JSON.parse(item));
          setOptions(uniqueFacilities);
        }
      }
    }
  }, [allPremises, regions, selectedRegion, type]);

  return (
    <span className="flex items-center">
      <div className="flex items-center bg-white border-2 border-[#a5b7cf] rounded-lg px-2 py-2 w-64 relative">
        <MapPin className="w-5 h-5 text-[#61748e]" />
        <select
          className="px-3 text-md text-[#5a687c] bg-pink font-medium outline-none flex-1 appearance-none"
          onChange={(e) => onChange(e.target.value)}
          value={selectedValue}
        >
          <option value="">
            {type === "region" ? "All Regions" : "All Premises"}
          </option>
          {premisesLoading || regionsLoading ? (
            <option disabled>Loading...</option>
          ) : (
            options.map((option) => (
              <option
                key={option.id}
                value={option.id}
                className="text-[#5a687c]"
                style={{ backgroundColor: "#f8f9fa" }}
              >
                {option.name}
              </option>
            ))
          )}
        </select>
        <ChevronDown className="w-4 h-4 text-gray-500 absolute right-4 pointer-events-none" />
      </div>
    </span>
  );
};
